import { render, staticRenderFns } from "./SegmentsList.vue?vue&type=template&id=6dd48852&scoped=true"
import script from "./SegmentsList.vue?vue&type=script&lang=ts"
export * from "./SegmentsList.vue?vue&type=script&lang=ts"
import style0 from "./SegmentsList.vue?vue&type=style&index=0&id=6dd48852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd48852",
  null
  
)

export default component.exports